(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9949],{

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 31016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ WrapperBanner; }
/* harmony export */ });
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70616);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53784);
/* harmony import */ var components_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66817);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function WrapperBanner(_ref) {
  var children = _ref.children,
      bannerInfo = _ref.bannerInfo;
  var _bannerInfo$styles = bannerInfo.styles,
      styles = _bannerInfo$styles === void 0 ? {} : _bannerInfo$styles;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var customClass = (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames) || ''] ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[(bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames) || ''] : bannerInfo === null || bannerInfo === void 0 ? void 0 : bannerInfo.classNames;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), customClass),
    style: _objectSpread({
      backgroundImage: "url(".concat(size.width < 768 ? bannerInfo.mUrl : bannerInfo.pcUrl, ")")
    }, styles),
    children: children
  });
}

var Index = function Index(props) {
  var bannerList = props.bannerList;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: bannerList.map(function (item, index) {
      var _item$more;

      item.more = (_item$more = item.more) !== null && _item$more !== void 0 ? _item$more : true;
      item.descStyle = item.descStyle || {};
      return /*#__PURE__*/_jsx(WrapperBanner, {
        bannerInfo: item,
        children: item.isContact ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: style.title,
              children: item.title
            }), /*#__PURE__*/_jsx("div", {
              className: style.desc,
              children: item.desc
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: style['contact-sale'],
            children: /*#__PURE__*/_jsx(Contact, {
              isTry: false
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: style.title,
            style: {
              color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
            },
            children: item.title
          }), /*#__PURE__*/_jsxs("div", {
            className: style.content,
            children: [/*#__PURE__*/_jsx("div", {
              className: style.desc,
              style: _objectSpread(_objectSpread({}, item.descStyle), {}, {
                color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
              }),
              children: item.desc
            }), item.more && /*#__PURE__*/_jsx(CustomLink, {
              isNextLink: false,
              href: item.link || '',
              className: style.more,
              styles: {
                color: (item === null || item === void 0 ? void 0 : item.color) || '#fff'
              },
              children: "\u4E86\u89E3\u66F4\u591A >"
            })]
          })]
        })
      }, item.pcUrl + index);
    })
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Index)));

/***/ }),

/***/ 58262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.module.scss
var index_module = __webpack_require__(89262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/product/relevance/nav/index.module.scss
var nav_index_module = __webpack_require__(73649);
var nav_index_module_default = /*#__PURE__*/__webpack_require__.n(nav_index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/relevance/nav/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */








var timer;

var Nav = function Nav(_ref) {
  var defaultIndex = _ref.defaultIndex,
      menu = _ref.menu,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 1 : _ref$type;

  var _useState = (0,react.useState)(defaultIndex || 0),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      once = _useState3[0],
      setOnce = _useState3[1]; //首次动画执行


  var count = (0,react.useRef)(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动

  var dom = (0,react.useRef)(null);
  var subNav = (0,react.useRef)();
  var menuRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var onScroll = (0,react.useCallback)(function () {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }

      setSticky(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  (0,react.useEffect)(function () {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);

  var requestAnimation = function requestAnimation() {
    var scrollTop = document.documentElement.scrollTop;
    var speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(function () {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  }; // 移动端-设置当前页面导航按钮是否在可视口完全显示


  (0,react.useEffect)(function () {
    var _menuRef$current;

    var childNodes = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.childNodes;

    if (childNodes && window.innerWidth < 768) {
      var child = childNodes[current];
      var position = child.getClientRects();
      var _position$ = position[0],
          left = _position$.left,
          width = _position$.width;
      var diff = left + width - window.innerWidth;

      if (diff > 0) {
        if (menuRef.current) {
          var distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);

  var Goto = function Goto(index, url) {
    setCurrent(index);
    router.push(url); // window.location.href = url;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: dom,
      className: classnames_default()((nav_index_module_default()).nav__theme_parent, once && (nav_index_module_default()).once, sticky && (nav_index_module_default()).sticky),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default()).logo, sticky && (nav_index_module_default()).show, !sticky && (nav_index_module_default()).hide),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "27"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default())["nav-pc"]),
        ref: subNav,
        children: menu.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return Goto(index, item.link);
            },
            className: classnames_default()((nav_index_module_default())["nav-pc-item"], index === current && (nav_index_module_default()).focus),
            children: item.name
          }, item.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((nav_index_module_default()).transition, count.current === 1 && (nav_index_module_default()).once, count.current > 1 && sticky && (nav_index_module_default()).active, 'for-pc')
    }), type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob"],
      ref: menuRef,
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    }), type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob-2"],
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    })]
  });
};

/* harmony default export */ var nav = (Nav);
;// CONCATENATED MODULE: ./src/components/product/relevance/wrapper/index.tsx









var menu1 = [{
  name: '智能硬件',
  link: '/hardware'
}, {
  name: '软件客户端',
  link: '/client'
}];
var menu2 = [{
  name: '一体化4K终端',
  link: '/hardware/fullSceneTerminal'
}, {
  name: '小鱼云镜',
  link: '/hardware/cloudMirrorSystem'
}, {
  name: '大型终端',
  link: '/hardware/flagshipTerminal'
}, {
  name: '中型终端',
  link: '/hardware/mediumTerminal'
}, {
  name: '中小型终端',
  link: '/hardware/integratedTerminal'
}, {
  name: '智能会议平板',
  link: '/hardware/meetingBoard'
}, {
  name: '电视墙服务器',
  link: '/hardware/TVwall'
}];
var menus = {
  '1': {
    name: '云视频会议',
    menu: menu1
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2
  }
};

var Wrapper = function Wrapper(_ref) {
  var title = _ref.title,
      current = _ref.current,
      children = _ref.children,
      _ref$menuIndex = _ref.menuIndex,
      menuIndex = _ref$menuIndex === void 0 ? '1' : _ref$menuIndex,
      customClass = _ref.customClass,
      pageKey = _ref.pageKey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    headerClass: (index_module_default()).header,
    children: [pageKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: pageKey
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [menus[menuIndex].name, "-", title]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((index_module_default()).main, customClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav, {
        menu: menus[menuIndex].menu,
        defaultIndex: current,
        type: menus[menuIndex].type || 1
      }), children]
    })]
  });
};

/* harmony default export */ var wrapper = (Wrapper);

/***/ }),

/***/ 6071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tdk; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/utils/tdk.ts
var TDK = {
  // 首页
  home: {
    title: '小鱼易连_视频会议_远程会议_超融合云视频会议系统_政府/企业数字化转型服务商',
    desc: '云视频、超融合云视频、视频会议、远程会议、视频会议系统、企业数字化转型',
    keyword: '小鱼易连创新打造“高安全·超融合·全连接”云视频会议，远程会议系统，专注为党政军央企，金融，学校，医院等大型组织及企业提供超融合视讯协作应用服务，领先通过等保三级+可信云双认证，实现国密算法端到端全链路加密。'
  },
  // 云视频会议
  product: {
    title: '小鱼易连_云视频会议系统_远程会议软件',
    desc: '小鱼易连打造“高安全·超融合·全连接”云视频会议系统,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务,领先通过等保三级+可信云双认证,实现国密算法端到端全链路加密。',
    keyword: '视频会议系统，视频会议软件，远程会议系统'
  },
  // 云视频平台
  productPlatform: {
    title: '小鱼易连_云视频平台',
    desc: '小鱼易连超融合云视频平台，通过统一的软件定义架构和安全设计，打造统一的支撑开发平台，保证视频会议、直播、点播、监控的融合互通，为全行业用户带来高品质的音视频体验。',
    keyword: '云视频平台'
  },
  // 智能硬件
  hardware: {
    title: '小鱼易连_云视频会议智能硬件_远程会议智能硬件',
    desc: '小鱼易连提供满足全场景应用的云视频会议智能硬件，包括大中小、室内外多场景终端，支持政务内外网、行业专网、互联网、4G/5G、卫星网等多网络灵活接入，实现个性化业务应用。',
    keyword: '云视频会议智能硬件'
  },
  // H.323硬件会议
  h323hardware: {
    title: '小鱼易连_H.323硬件会议_远程会议',
    desc: '小鱼易连H.323硬件会议，支持H.323/SIP标准，为传统H.323/SIP产品提供云视频体验，兼容异构品牌视频会议。',
    keyword: 'H.323硬件会议'
  },
  // 软件客户端
  productClient: {
    title: '小鱼易连_云视频会议软件客户端',
    desc: '小鱼易连云视频会议软件客户端，适用于Windows、Mac、iOS/Android客户端音视频互动、内容共享、会议主持、直播、录制、点播等功能。',
    keyword: '云视频会议软件客户端'
  },
  // 指挥调度客户端
  commandDispatch: {
    title: '小鱼易连_云视频会议指挥调度客户端',
    desc: '小鱼易连云视频会议指挥调度客户端，用于管理员或指挥调度人员进行专业会议管理、综合视频调度，可对内部所有会议或会场进行监管，并对接监控平台构建一体化的会议与监控融合调度平台。',
    keyword: '云视频会议指挥调度客户端'
  },
  // 未来教育
  education: {
    title: '小鱼易连_未来教育',
    desc: '小鱼易连面向未来教育，打造教育全融合视频互动解决方案，借助统一教育视频应用平台，实现互动、直播、点播、资源分享、教学管理、AI智能等多场景融合应用，促进教育均衡发展。',
    keyword: '未来教育'
  },
  // 教育视频能力中枢
  videoCenter: {
    title: '小鱼易连_教育视频能力中枢_未来教育',
    desc: '小鱼易连教育视频能力中枢，以核心云视频技术优势，实现高清流畅的音视频交互体验，为学校、教师、学生提供专业的音视频云服务，打破地区教育发展瓶颈，助力教育公平和均衡发展。',
    keyword: '教育视频能力中枢'
  },
  // 教育资源管理平台
  educationPlatform: {
    title: '小鱼易连_教学管理与资源平台_未来教育',
    desc: '小鱼易连教学管理与资源平台是支撑互动课堂的核心教学平台，包含云录播和直播、协同备课、远程教研、在线督导、教学运维、数据分析、资源汇聚、资源管理等多应用。',
    keyword: '教学管理与资源平台'
  },
  // 智能互动教学终端
  educationTerminal: {
    title: '小鱼易连_智能视频互动教学终端_未来教育',
    desc: '小鱼易连智能互动教学终端，以云视频技术为核心，以教学业务为指导，帮助教育用户轻松实现课程资源建设、三个课堂、网络教研、教育直播、家校互动的常态化应用，助力教育资源优质均衡。',
    keyword: '智能互动教学终端'
  },
  // 小鱼易连开发平台
  api: {
    title: '小鱼易连_开发平台',
    desc: '小鱼易连打造具备业务和场景创新能力、支持API和SDK定制化接入的泛业务开发平台，是可视数字化新连接广泛完善和不断深化的创新支撑。',
    keyword: '开发平台'
  },
  // 互动音视频
  apiAv: {
    title: '小鱼易连_互动音视频',
    desc: '小鱼易连提供全平台SDK及API接口，能与主流的办公协同应用对接和集成，提供安全、稳定、高清的互动音视频服务，适用协同办公、在线教育、金融双录、视频客服、远程医疗等应用。',
    keyword: '互动音视频'
  },
  // 多方会议调度
  apiDispatch: {
    title: '小鱼易连_多方会议调度',
    desc: '小鱼易连通过与各种指挥调度、业务管理、可视化等系统进行快速对接和集成，提供多方会议调度能力，广泛应用于会议会商、指挥调度、指挥党建、远程调解、互动培训等应用场景。',
    keyword: '多方会议调度'
  },
  // 互动会议直播
  apiLive: {
    title: '小鱼易连_互动会议直播',
    desc: '小鱼易连互动会议直播，通过易用的直播和录播API接口集成，可以快速实现大型活动、远程培训、企业年会、智慧党建、营销活动的直播或点播应用，单场并发规模可达百万级。',
    keyword: '互动会议直播'
  },
  // 教育api产品
  apiEducation: {
    title: '小鱼易连_教育API产品',
    desc: '小鱼易连教育API产品，接口功能覆盖引擎管理、课程及用户管理、音视频通话质量管理及课内外应用状态监测等全业务流程，可协助客户快速完成从前端教学应用到运维及后台管理的完整业务体系开发。',
    keyword: '教育API产品'
  },
  // 政务行业
  govSolution: {
    title: '小鱼易连_政府服务行业云视频会议解决方案',
    desc: '小鱼易连提供自主创新云视频技术和政务云视频顶层设计方案，将云视频应用从会议室延展到个人互联、移动接入、融合调度、政务服务等多场景，全面提升政务数字化水平，助力政府数字化转型。',
    keyword: '政府服务行业云视频会议解决方案'
  },
  //政法行业
  govLow: {
    title: '小鱼易连_智慧政法行业数字化解决方案',
    desc: '小鱼易连通过构建一体化“智慧政法”全融合云视频平台，促进司法行政效率和公共法律服务水平提升，助力执法规范化、管理精细化、服务透明化，推进法治现代化建设。',
    keyword: '智慧政法行业数字化解决方案'
  },
  // 企业集团
  group: {
    title: '小鱼易连_企业集团行业智能云会议/协同办公解决方案',
    desc: '小鱼易连通过“高安全·超融合·全连接”的云视频整体解决方案，深度融合企业集团业务需求，可高效支撑企业远程会议、协同办公、视频客服等日常或定制场景应用，赋能企业集团数字化转型升级。',
    keyword: '企业集团行业智能云会议解决方案，企业集团行业协同办公解决方案'
  },
  // 金融行业
  finance: {
    title: '小鱼易连_金融行业数字化转型解决方案',
    desc: '小鱼易连以“数字化、科技引领、创新驱动”为整体布局驱动，为金融行业提供安全、便捷的云视频中台服务，适应金融业务需求和网络条件灵活部署，助力金融机构实现管理数字化、科技化、智能化。',
    keyword: '金融行业数字化转型解决方案'
  },
  // 教育行业
  eduSolution: {
    title: '小鱼易连_教育行业解决方案',
    desc: '教育全融合视频互动解决方案，以云视频互动技术为核心，实现互动教学、同步课堂、远程教研、督导巡课、视频会议、考场监控、校园安全等智慧教育场景的融合应用，为教育用户构建教、学、研、管、评及组织办公协同的一站式音视频应用生态体系，促进教育优质均衡，实现“蓝天下·同课堂”。',
    keyword: '教育行业解决方案'
  },
  // 医疗行业
  medical: {
    title: '小鱼易连_医疗行业分级诊疗解决方案',
    desc: '小鱼易连通过整合业务系统为远程医疗提供数据及流程支撑，打造全流程、全网络、全场景、全贯通、全业务的远程医疗平台，帮助患者实现远程就医，提升基层医生医疗水平，提高医疗救治服务效率，推动基层医疗发展，促进分级诊疗，优化医疗资源配置，创新互联网医院发展模式，推动区域医疗协同发展。',
    keyword: '医疗行业分级诊疗解决方案'
  },
  //水利行业
  waterConservancy: {
    title: '小鱼易连_水利行业智慧水利解决方案',
    desc: '小鱼易连打造集水利会议系统、监控系统、单兵系统、指挥车等于一体的音视频集控系统，满足大规模、多场景、广覆盖、全业务嵌入的内外部高清视频沟通需求，赋能数字孪生水利工程建设，助力水利治理、防汛抗旱等日常智慧管理。',
    keyword: '水利行业智慧水利解决方案'
  },
  //应急行业
  emergency: {
    title: '小鱼易连_应急行业云视频解决方案',
    desc: '小鱼易连采用云计算与虚拟化技术，构建一体化“应急指挥融合平台”，通过标准音视频通信协议与各级单位、部门机构的视频系统实现互通互联，实现全时空、多部门、多业务的视频协同，让应急指挥直达一线，加快推进应急管理体系现代化。',
    keyword: '应急行业云视频解决方案'
  },
  // 法院
  court: {
    title: '小鱼易连_法院视频会议解决方案',
    desc: '小鱼易连法院视频会议解决方案，通过“高安全·超融合·全连接”云视频，可实现互联网庭审、多方协调、一乡一庭、移动法庭、庭审直播、远程庭审等，让司法程序高效便捷。',
    keyword: '法院视频会议解决方案'
  },
  // 检察院
  procuratorate: {
    title: '小鱼易连_检察院视频会议解决方案',
    desc: '小鱼易连检察院视频会议解决方案，通过“高安全·超融合·全连接”云视频，高效实现检法协同、远程汇报、分析讲座、远程提审、三方提审等多场景应用，实现检务工作智慧化。',
    keyword: '检察院视频会议解决方案'
  },
  // 税务
  tax: {
    title: '小鱼易连_税务视频会议解决方案',
    desc: '小鱼易连税务视频会议解决方案，依托“高安全·超融合·全连接”云视频技术，实现多级会议、在线交流、纳服协作、数据管税、税务普法等应用。',
    keyword: '税务视频会议解决方案'
  },
  // 远程办公
  telecommuting: {
    title: '小鱼易连_企业远程办公视频会议解决方案',
    desc: '小鱼易连提供远程办公视频会议解决方案，员工使用PC/Mac、手机，通过家庭宽带或4G网络就能实现多方高清会议，可共享Word、PPT、Excel等各种文档，会后还可生成音视频记录。',
    keyword: '企业远程办公视频会议，远程办公视频会议解决方案'
  },
  // 在线课堂
  onlineTeaching: {
    title: '小鱼易连_在线课堂视频会议解决方案',
    desc: '小鱼易连在线课堂视频会议解决方案，助力停课不停学。在社会应急或特殊时期，老师可在校使用专业云视频硬件终端或在家使用电脑授课，学生在家用电脑、平板或手机上课，可实时双向交流。',
    keyword: '在线课堂视频会议解决方案'
  },
  // 交通行业
  traffic: {
    title: '小鱼易连_交通行业视频会议远程会议解决方案',
    desc: '小鱼易连交通行业视频会议解决方案，以“高安全·超融合·全连接”的云视频技术，助力交通行业信息化建设，满足视频沟通、应急处理、统一调度、综合执法、巡查巡检等业务应用需求。',
    keyword: '交通行业视频会议解决方案'
  },
  // 核心优势
  advantage: {
    title: '小鱼易连_远程视频会议核心优势',
    desc: '小鱼易连远程视频会议核心优势业内领先，超大规模的运营级云视频平台、AI智能超高清会议、领先“SVC+AVC”双引擎架构、全面自主安全可靠。',
    keyword: '远程视频会议核心优势'
  },
  // 公司新闻
  news: {
    title: '小鱼易连_视频会议新闻资讯_让世界零距离',
    desc: '小鱼易连创新打造“高安全·超融合·全连接”云视频,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务，实时更新视频会议新闻资讯。',
    keyword: '视频会议新闻资讯'
  },
  // 三个课堂
  threeClass: {
    title: '小鱼易连_三个课堂',
    desc: '小鱼易连三个课堂解决方案采用“云+硬件终端+开发平台+AI“整体架构，连接区域内、区域间优质校和薄弱校，为全体师生构建高质量的学习、教研、培训和交流的平台与通道。咨询热线：400-900-3567。',
    keyword: '三个课堂'
  },
  //超融合视频平台
  platform: {
    title: '小鱼易连_超融合云视频平台解决方案',
    desc: '超融合云视频平台解决方案',
    keyword: '小鱼易连采用新一代智能云化架构和先进的音视频算法，功能丰富，性能强大，部署灵活，易管易用，为用户提供安全、稳定、高品质的音视频体验。'
  }
};
var getTdk = function getTdk(key) {
  if (!TDK[key]) return TDK['home'];
  return TDK[key];
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/tdk/index.tsx






var Index = function Index(props) {
  var _getTdk = getTdk(props.pageKey),
      title = _getTdk.title,
      keyword = _getTdk.keyword,
      desc = _getTdk.desc;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: keyword
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: desc
    })]
  });
};

/* harmony default export */ var tdk = (Index);

/***/ }),

/***/ 51732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53784);
/* harmony import */ var components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58262);
/* harmony import */ var components_product_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31016);
/* harmony import */ var components_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66817);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69490);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
/*
 * 智能硬件
 */









var IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/hardware/hard/';
var bannerList = [{
  bigTitle: '体验可移动全场景灵动视界 ',
  headerImg: "".concat(IMG_PREFIX, "img0.jpg"),
  headerImgM: "".concat(IMG_PREFIX, "M/imgM0.jpg"),
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img0.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img1.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner))
  },
  title: '一体化4K全场景终端',
  desc: '有型视界，远程办公头等舱',
  link: '/hardware/fullSceneTerminal'
}, {
  bigTitle: '打造会议室智慧视讯空间',
  headerImg: "".concat(IMG_PREFIX, "img1.jpg"),
  headerImgM: "".concat(IMG_PREFIX, "M/imgM2.jpg"),
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img1.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img2.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner))
  },
  title: '小鱼云镜沉浸式远真',
  desc: '真人面对面，天涯若比邻',
  link: '/hardware/cloudMirrorSystem'
}, [{
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img7.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img7.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().totalBanner))
  },
  title: '大型会议室全4K旗舰终端',
  desc: '纵享至臻大场面',
  link: '/hardware/flagshipTerminal'
}, {
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img4.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img04.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().totalBanner))
  },
  title: '中型会议室分体式终端',
  desc: '专业不凡，高性能新体验',
  link: '/hardware/mediumTerminal'
}, {
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img5.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img5.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().totalBanner))
  },
  title: '中小型会议室一体式终端',
  desc: '方寸间掌控大视界',
  link: '/hardware/integratedTerminal'
}, {
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img6.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img6.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner), (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().totalBanner))
  },
  title: '智能会议平板',
  desc: '原生云视频，高效智慧协同',
  link: '/hardware/meetingBoard'
}], {
  bigTitle: '搭建高效指挥调度窗口',
  headerImg: "".concat(IMG_PREFIX, "img2.jpg"),
  headerImgM: "".concat(IMG_PREFIX, "M/imgM1.jpg"),
  bannerInfo: {
    mUrl: "".concat(IMG_PREFIX, "M/bg-img2.jpg"),
    pcUrl: "".concat(IMG_PREFIX, "bg-img00.jpg"),
    classNames: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().banner))
  },
  title: '电视墙服务器',
  desc: '统一调度，海量高清画面尽收眼底',
  link: '/hardware/TVwall'
}];

var Hard = function Hard() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    title: "\u667A\u80FD\u786C\u4EF6",
    pageKey: "hardware",
    current: 0,
    customClass: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().hardware),
    children: [bannerList.map(function (item, index) {
      return Array.isArray(item) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().horizontal),
        children: item.map(function (childItem) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_product_banner__WEBPACK_IMPORTED_MODULE_4__/* .WrapperBanner */ .G, {
            bannerInfo: childItem.bannerInfo,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrap),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                  children: childItem.title
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().desc),
                  children: childItem.desc
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                  isNextLink: false,
                  href: childItem.link,
                  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().knowMore),
                  children: "\u4E86\u89E3\u66F4\u591A >"
                })]
              })
            })
          }, childItem.title);
        })
      }, index) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().contentWrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(components_product_banner__WEBPACK_IMPORTED_MODULE_4__/* .WrapperBanner */ .G, {
          bannerInfo: item.bannerInfo,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
            children: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().desc),
            children: item.desc
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            isNextLink: false,
            href: item.link,
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().knowMore),
            children: "\u4E86\u89E3\u66F4\u591A >"
          })]
        }, item.title)
      });
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().contact),
      btnType: 'newBtn'
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Hard);

/***/ }),

/***/ 94142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var UseResize = function UseResize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setSize({
      width: document.documentElement.clientWidth
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    onResize();
  }, [onResize]);
  return size;
};

/* harmony default export */ __webpack_exports__["Z"] = (UseResize);

/***/ }),

/***/ 63201:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware",
      function () {
        return __webpack_require__(51732);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 70616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"banner_border__px__77VaN","border__px-before":"banner_border__px-before__Jry1M","border__px-before1":"banner_border__px-before1__NgqyB","border-children1":"banner_border-children1__E1JOH","border-children2":"banner_border-children2__KG07W","for-mobile":"banner_for-mobile__cWt3q","for-pc":"banner_for-pc__Fxcge","MBanner":"banner_MBanner__IIZdl","forM":"banner_forM__uoxiH","container":"banner_container__XMgym","title":"banner_title__cvfTo","content":"banner_content__vv4Vk","desc":"banner_desc__czCk5","more":"banner_more__KkMR3","contact-sale":"banner_contact-sale__9p0a9","bannerFirst":"banner_bannerFirst__n8g55","first":"banner_first__K2I_l","forPC":"banner_forPC__Dp6FK"};

/***/ }),

/***/ 73649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"nav_border__px__LnplE","border__px-before":"nav_border__px-before__EVov9","border__px-before1":"nav_border__px-before1__2oD1e","border-children1":"nav_border-children1__g0F3X","border-children2":"nav_border-children2__DnnSf","for-mobile":"nav_for-mobile__ZciXU","for-pc":"nav_for-pc__z_KI0","nav__theme_parent":"nav_nav__theme_parent__T4U4O","logo":"nav_logo__WR8zR","show":"nav_show__4YtHP","nav-pc":"nav_nav-pc__bFsJ0","nav-pc-item":"nav_nav-pc-item__kYYYW","focus":"nav_focus__ByYUr","once":"nav_once__aksOZ","sticky":"nav_sticky__l7SSZ","transition":"nav_transition__B1wHH","active":"nav_active__1D68f","nav-mob":"nav_nav-mob__FuCYJ","nav-mob-2":"nav_nav-mob-2__6Mv2f","nav-mob-item":"nav_nav-mob-item__6k_Rb"};

/***/ }),

/***/ 89262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"wrapper_border__px__F6VvU","border__px-before":"wrapper_border__px-before__Mxpn1","border__px-before1":"wrapper_border__px-before1__EFvO6","border-children1":"wrapper_border-children1__KmKjR","border-children2":"wrapper_border-children2__7Jboy","for-mobile":"wrapper_for-mobile__2kveH","for-pc":"wrapper_for-pc__yuzrw","layout":"wrapper_layout__j4SAy","header":"wrapper_header__l9dYm"};

/***/ }),

/***/ 69490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"hardware_border__px__CtHzP","border__px-before":"hardware_border__px-before__kYRb1","border__px-before1":"hardware_border__px-before1__trY_O","border-children1":"hardware_border-children1__7tsC_","border-children2":"hardware_border-children2__fWazN","for-mobile":"hardware_for-mobile__a5zi1","for-pc":"hardware_for-pc__k4Hz2","hardware":"hardware_hardware__Kr1ya","contentWrapper":"hardware_contentWrapper__B6mJl","header":"hardware_header__2vITb","bigTitle":"hardware_bigTitle__IIehz","arrowImg":"hardware_arrowImg__NsFsl","horizontal":"hardware_horizontal__Xb_Jf","totalBanner":"hardware_totalBanner__Sj6JV","banner":"hardware_banner__Cp8u_","title":"hardware_title__qVrv1","desc":"hardware_desc__Qd964","knowMore":"hardware_knowMore__tGycx","contact":"hardware_contact__AirZV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(63201); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);